import { data as routerData } from 'react-router';
import type { ActionFunctionArgs } from '~/types/route-args';
import { setLabelledImageHidden } from '~/modules-rocco/projects/api/set-labelled-image-hidden.server';
import { canModerateImageLabels } from '~/modules-rocco/projects/config/image-label-visibility.server';

/**
 * Staff endpoint behind the Hide / Restore button in the Spaces and Styles viewer.
 *
 * `POST` with `libraryImageID` and `hidden` (`true` hides, anything else restores). The staff check
 * here spares a visitor the round trip; PHP re-checks it, because a hidden button is not a
 * security boundary.
 */
export const LABELLED_IMAGE_VISIBILITY_API_ROUTE =
    '/remix-api/labelled-image-visibility';

export const action = async ({ request, context }: ActionFunctionArgs) => {
    if (!canModerateImageLabels(context)) {
        return routerData(
            { ok: false as const, message: 'Not found', changed: 0 },
            { status: 404, statusText: 'Not Found' },
        );
    }

    const formData = await request.formData();
    const libraryImageID = Number(formData.get('libraryImageID'));
    if (!Number.isInteger(libraryImageID) || libraryImageID <= 0) {
        return { ok: false as const, message: 'Choose an image.', changed: 0 };
    }

    return setLabelledImageHidden(
        context,
        libraryImageID,
        String(formData.get('hidden')) === 'true',
    );
};
